import { Layout } from "antd";
import styled from "styled-components";

const { Header } = Layout;

export const StyledHeader = styled(Header)`
  background-color: white;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 24px 0 0;
  align-items: center;
  margin-bottom: 20px;
`;

export const StyledPageHeader = styled.div`
  width: 100%;
  background: transparent;
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
  border-bottom: 1px solid rgba(8, 10, 12, 0.175);
  .title-span {
    font-weight: 500;
    font-size: 1.5rem;
  }
  .sub-title-span {
    font-weight: 500;
    font-size: 1rem;
  }
`;
